export const BILL_CATEGORIES = ["Housing", "Utilities", "Phone & Internet", "Insurance", "Subscriptions", "Medical", "School", "Car", "Other"];
export const SPENDING_CATEGORIES = ["Groceries", "Dining", "Housing", "Utilities", "Phone & Internet", "Insurance", "Subscriptions",
  "Medical", "School", "Car", "Kids", "Entertainment", "Travel", "Shopping", "Other"];
export const slug = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, "-");

export async function copyText(text) {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch (_) {
    const ta = document.createElement("textarea");
    ta.value = text;
    ta.style.position = "fixed";
    ta.style.opacity = "0";
    document.body.appendChild(ta);
    ta.select();
    const ok = document.execCommand("copy");
    document.body.removeChild(ta);
    return ok;
  }
}
